import React from 'react';

const ChromeIcon = () => {
  return (
    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6262 0.00221373C12.6262 0.00221373 19.9679 -0.327246 23.8603 7.05226H12.0015C12.0015 7.05226 9.76354 6.98012 7.8518 9.69514C7.30263 10.8347 6.71234 12.0086 7.37476 14.322C6.4205 12.7053 2.30859 5.54552 2.30859 5.54552C2.30859 5.54552 5.20891 0.293951 12.6261 0.00221373H12.6262Z"
        fill="#EF3F36"
      />
      <path
        d="M23.4793 18.7359C23.4793 18.7359 20.0915 25.2607 11.7578 24.9381C12.7875 23.1567 17.6889 14.6685 17.6889 14.6685C17.6889 14.6685 18.8731 12.767 17.4761 9.75344C16.7655 8.70658 16.0413 7.61166 13.7074 7.02809C15.5849 7.01103 23.8397 7.02809 23.8397 7.02809C23.8397 7.02809 26.9321 12.1664 23.4793 18.7359Z"
        fill="#FCD900"
      />
      <path
        d="M1.82515 18.7874C1.82515 18.7874 -2.13236 12.592 2.31592 5.53516C3.34222 7.31658 8.24356 15.8047 8.24356 15.8047C8.24356 15.8047 9.30076 17.7818 12.6061 18.0768C13.8658 17.9842 15.1769 17.9053 16.852 16.1788C15.9285 17.8127 11.7856 24.9519 11.7856 24.9519C11.7856 24.9519 5.78597 25.0618 1.82505 18.7874H1.82515Z"
        fill="#61BC5B"
      />
      <path
        d="M11.7559 24.9999L13.4239 18.0392C13.4239 18.0392 15.2568 17.8949 16.7945 16.2097C15.8403 17.8882 11.7559 24.9999 11.7559 24.9999Z"
        fill="#5AB055"
      />
      <path
        d="M7.03906 12.5782C7.03906 9.50973 9.52755 7.02124 12.596 7.02124C15.6645 7.02124 18.153 9.50973 18.153 12.5782C18.153 15.6467 15.6645 18.1351 12.596 18.1351C9.52755 18.1317 7.03906 15.6467 7.03906 12.5782Z"
        fill="white"
      />
      <path
        d="M7.96875 12.5784C7.96875 10.0248 10.0385 7.95166 12.5956 7.95166C15.1492 7.95166 17.2224 10.0214 17.2224 12.5784C17.2224 15.1321 15.1527 17.2053 12.5956 17.2053C10.0419 17.2053 7.96875 15.1321 7.96875 12.5784Z"
        fill="url(#paint0_linear_2802_160)"
      />
      <path
        d="M23.8373 7.03169L16.9692 9.04646C16.9692 9.04646 15.9326 7.52588 13.7051 7.03169C15.6375 7.02136 23.8373 7.03169 23.8373 7.03169Z"
        fill="#EACA05"
      />
      <path
        d="M7.24093 14.0679C6.27634 12.3963 2.30859 5.54541 2.30859 5.54541L7.39533 10.5772C7.39533 10.5772 6.87356 11.6515 7.06928 13.1892L7.24084 14.0679H7.24093Z"
        fill="#DF3A32"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2802_160"
          x1="12.5954"
          y1="8.01699"
          x2="12.5954"
          y2="16.9267"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#86BBE5" />
          <stop offset="1" stopColor="#1072BA" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ChromeIcon;